import QRCode from "react-qr-code";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "react-bootstrap";
import { useState } from "react";
import { getConfig } from "../../config/apiSPA";

function ModalEventTel1Qr({ show, onHide, data, id, submitClick }) {
  const [tel1Url, setTel1Url] = useState(null);
  const handleOnshow = () => {
    getConfig().then((res) => setTel1Url(res.tel1BaseUrl));
  };
  return (
    <>
      <Modal show={show} onShow={handleOnshow} onHide={() => onHide()}>
        <ModalHeader closeButton>
          <h5 className="modal-title">Event Qr</h5>
        </ModalHeader>
        {tel1Url ? (
          <>
            <ModalBody>
              <div className="text-center">
                <p>Please Scan qr code event or click link bellow</p>
              </div>
              <div style={{ height: "auto", margin: "0 auto", maxWidth: 256, width: "100%" }}>
                <QRCode size={256} style={{ height: "auto", maxWidth: "100%", width: "100%" }} value={`${tel1Url}/${data.path_key}`} viewBox={`0 0 256 256`} />
              </div>
              <div className="text-center mt-3">
                <a href={`${tel1Url}/${data.path_key}`}>{`${tel1Url}/${data.path_key}`}</a>
              </div>
            </ModalBody>
            <ModalFooter>
              <button onClick={() => submitClick()} type="button" className="btn btn-outline-theme">
                Got it
              </button>
            </ModalFooter>
          </>
        ) : (
          <p>Loading.....</p>
        )}
      </Modal>
    </>
  );
}

export default ModalEventTel1Qr;
